export default __webpack_public_path__ + "static/media/caret-up.c099db8e.svg";